// A session generation owns async UI work, not just a user id. Signing out
// retires it immediately, including callbacks that finish after signing back
// into the same account. This does not delete browser or server history.
export function createSessionBoundary() {
  let userId: string | null | undefined;
  let generation = 0;
  let current = () => generation === 0;
  return {
    get userId() {
      return userId;
    },
    get generation() {
      return generation;
    },
    capture(expectedUserId = userId): () => boolean {
      return expectedUserId === userId ? current : () => false;
    },
    transition(nextUserId: string | null): boolean {
      if (nextUserId === userId) return false;
      userId = nextUserId;
      const ownedGeneration = ++generation;
      current = () => generation === ownedGeneration;
      return true;
    },
  };
}
